import ko from 'knockout'
import _ from '../../util/lodash'
import Base from '../../core/base'
import util from './gridutil'
import fastDom from 'fastdom'
const PAGESIZE = 10
const PAGEINDEX = 0
const MIN_TR_HEIGHT = 44
// 需要支持外部修改crossPageSeletedRows 同时内部全选的时候又不触发
let isTriggerInside = false
// 获取视窗宽度，一般表格比视窗窄不了多少
let clientWidth = 0
class Grid extends Base {
  initialize (params) {
    clientWidth = document.body.clientWidth + 100
    // 支持表头通过ctrl+click 多级排序
    this.groupSort = ko.observable(params.groupSort || false)
    this.fieldid = params.fieldid
    // 支持键盘操作
    this.aria = params.aria
    this.fieldid = params.fieldid
    this.hidefix = ko.observable(false).extend({
      deferred: true
    })
    this.columnsFilterable = !!params.columnsFilterable
    this.showColumnFilter = ko.observable(false)
    this.toolbox = params.toolbox || false
    this.maxLazyRows = params.maxLazyRows || 50
    this.setting = {
      borderLight: ko.observable(true),
      borderDark: ko.observable(false),
      borderDarker: ko.observable(false)
    }
    this.defaultValue = Object.assign({
      _disable: false
    }, params.defaultValue || {})
    this.toolboxvisible = ko.observable(false)
    this.lazy = params.lazy
    this.lockColumnHeight = ko.observable({})
    this.isDataTable = params.isDataTable || false
    this.hasSummaryRow = params.hasSummaryRow || false
    this.hasChildGrid = params.hasChildGrid || false
    this.caculateColumns = params.caculateColumns
    // 只有当columns1和columns2一起启用的时候才认为是启用了rowspanhead
    this.isRowspanHead = !!params.columns1 && !!params.columns2
    this.headtransform = ko.observable('translateX(0)')
    this.fixColumnTransform = ko.observable('translateY(0)')
    this.vertiacalScrollTransform = ko.observable({})
    this.lockRightWidth = 0
    this.fixRightHeadtransform = ko.observable('translateX(0)')
    this.fixRightTransform = ko.observable('translate(0,0)')
    this.rowspan = params.rowspan
    this.domId = params.rowspan ? Math.random() : ''
    this.isTableBorder = params.isTableBorder || params.rowspan
    // fixed 把maxheight改成ko对象
    this.maxheight = ko.isObservable(params.maxheight) ? params.maxheight : ko.observable(params.maxheight || '486px')
    // fixed issue 111 当设置了auto之后，需要把外层y-grid的overflow设置成visible，防止auto+更多操作按钮的组合遮挡住浮动框
    this.isAutoHeight = ko.utils.unwrapObservable(params.maxheight) === 'auto'
    this.minheight = params.minheight || 'auto'
    this.isStripe = params.isStripe || false
    this.expand = params.expand || true
    // 是否启用自定义的transform
    this.verticalScroll = params.verticalScroll || false
    this.scrollStyle = params.scrollStyle || {}
    // 是否显示loading图标
    this.isShowLoading = ko.observable(false)
    // 是否隐藏表头
    this.nohead = params.nohead || false
    this.noborder = params.noborder || false
    // expand是否默认展开
    this.defaultExpand = params.defaultExpand || false
    // 是否启用分页组件
    this.pagination = ko.observable(params.pagination || false)
    // 是否启用固定列
    this.lockcolumn = ko.isObservable(params.lockcolumn) ? params.lockcolumn : ko.observable(params.lockcolumn || false)
    this.lockright = params.lockright || false
    this.showLockRightToolBar = ko.observable(true)
    // 固定表头
    this.lockhead = params.lockhead || this.lockcolumn()

    this.headHeight = params.headHeight ? ko.observable(params.headHeight) : ko.observable('29px')
    this.scrollHeight = params.scrollHeight || '15px'
    this.startIndex = params.startIndex || 0
    this.pageSize = params.pageSize || ko.observable(PAGESIZE)
    this.pageIndex = params.pageIndex || ko.observable(PAGEINDEX)
    this.pageSizeList = params.pageSizeList
    this.totalCount = params.totalCount || ko.observable(0)
    this.tdstyle = params.tdstyle || {}
    this.verticalAlign = params.verticalAlign || 'middle'
    // event binding
    // 行选中
    this.onRowSelect = params.onRowSelect || function () { }
    this.onPageChange = params.onPageChange
    this.onSizeChange = params.onSizeChange
    this.isSeparate = params.isSeparate || false
    this.style = params.style || {}
    this.forbitRowSelect = ko.observable(params.forbitRowSelect || false)
    this.forbitRowSelectFn = params.forbitRowSelectFn
    // 放在弹框内部的需要动态内部高度
    this.modalBodyModalHeight = params.modalBodyModalHeight || 0
    this.modalBodyExtraHeight = params.modalBodyExtraHeight || '0'
    this.onModalOkValidate = params.onModalOkValidate || function () { }
    // add by songhlc 2018-01-02 添加grid跨页选中功能
    this.crossPageSelectedRows = params.crossPageSelectedRows // 如果rows的是datatable那么这里存的row就是datatable的row
    // 默认使用id属性做为行唯一标识符
    this.crossPageRowPrimaryKey = params.crossPageRowPrimaryKey || 'id'
    // 用于判断是否启用跨页选择
    this.isEnableCrossPage = Boolean(this.crossPageSelectedRows)
    // 用于触发宽度重新计算
    this.reComputedTableWidth = ko.observable(false)
    // 当前表格的leftBoy、rightBody、mainBody引用
    this.bodyrefs = {
      mainbody: '',
      leftBody: '',
      rightBody: ''
    }
    this.children = {
      body: ''
    }
  }
  computed (params) {
    var that = this
    if (this.toolbox) {
      this.borderActive = ko.computed(() => {
        if (this.setting.borderDarker()) {
          return 'Darker'
        } else if (this.setting.borderDark()) {
          return 'Dark'
        } else {
          return 'Light'
        }
      })
    }
    // 计算表格最高高度
    this.computedMaxHeight = ko.computed(() => {
      var maxheight = this.maxheight()
      // 如果是在modal中，maxheight = 外层height - extraHeight - paginationHeight - 内层padding高度
      if (maxheight === 'auto') {
        return 'auto'
      } else if (this.modalBodyModalHeight) {
        var _modalBodyModalHeight = this.modalBodyModalHeight.toString().replace('px', '')
        var _modalBodyExtraHeight = this.modalBodyExtraHeight.replace('px', '')
        var _paginationHeight = 0
        var _paddingHeight = 33 // padding+border高度
        if (this.pagination()) {
          _paginationHeight = 36
        }
        var result = _modalBodyModalHeight - _modalBodyExtraHeight - _paginationHeight - _paddingHeight
        // 如果超过允许外层的最大高度
        if (maxheight.replace('px', '') - 0 > result) {
          return result + 'px'
        } else {
          return maxheight
        }
      } else {
        return maxheight
      }
    })
    // 用来动态高度计算用的
    this.columnNumberHeight = ko.pureComputed(() => {
      var item = this.lockColumnHeight()
      var length = this.rows.peek().length
      var array = new Array(length)
      for (var i = 0; i < length; i++) {
        array[i] = MIN_TR_HEIGHT
      }
      Object.keys(item).map(function (key) {
        array[key] = item[key].height.replace('px', '') - 0
      })
      return array
    }).extend({
      deferred: true
    })
    // 外部使用判断当前合适的高度 用于每一行高度不一致的时候
    // 由于更新问题 可能返回-1 当返回-1时需要和外部
    // 老代码 不推荐使用
    this.getFitIndexByScrollTop = (destHeight) => {
      var sum = 0
      var index = -1
      var lockColumnHeight = this.columnNumberHeight()
      for (var i = 0; i < lockColumnHeight.length; i++) {
        if (destHeight > sum) {
          sum += lockColumnHeight[i]
        } else {
          index = i
          break
        }
      }
      return index
    }
    // 外部使用判断当前合适的高度 用于每一行高度不一致的时候
    this.getCurIndexByScrollTop = (destHeight) => {
      var sum = 0
      var index = -1
      var lockColumnHeight = this.columnNumberHeight()
      for (var i = 0; i < lockColumnHeight.length; i++) {
        if (destHeight > sum) {
          sum += lockColumnHeight[i]
        } else {
          index = i
          break
        }
      }
      if (index === -1) {
        // 有些没有算对的高度 通过最小高度来补齐
        index = lockColumnHeight.length + Math.round((destHeight - sum) / MIN_TR_HEIGHT)
      }
      return index
    }
    // 已选中的ids
    this.crossPageSelectedIds = ko.computed(() => {
      if (this.isEnableCrossPage) {
        return this.crossPageSelectedRows().map((row) => {
          if (this.isDataTable) {
            return row.ref(this.crossPageRowPrimaryKey)()
          } else {
            return row[this.crossPageRowPrimaryKey]
          }
        })
      } else {
        return []
      }
    }).extend({
      defered: true
    })
    this.rows = ko.computed(() => {
      // 如果是内部设置setRowSelect 则不重新触发,直接返回原来的数据
      if (!isTriggerInside) {
        var datas = params.rows()
        datas.forEach((row, index) => {
          // 减轻重复赋值的压力
          if (!row._delete) {
            row._delete = ko.observable(false)
          }
          if (!row._hover) {
            row._hover = ko.observable(false)
          }

          if (!row._disabled) {
            row._disabled = ko.observable(this.defaultValue._disable)
          }
          if (!row._expand) {
            row._expand = ko.observable(this.defaultExpand)
          }

          // 用户保存行状态
          !row._rowStatus && (row._rowStatus = ko.observable(''))
          if (this.isDataTable) {
            // 如果是dataTable设置成计算属性
            !row._selected && (row._selected = ko.pureComputed({
              read: function () {
                return row.selected()
              },
              write: function (val) {
                isTriggerInside = true
                // 设置datatable的选中
                if (val) {
                  row.parent.addRowSelect(row)
                } else {
                  row.parent.setRowUnSelect(row)
                }
                if (that.crossPageSelectedRows) {
                  // 设置已选中rows的值
                  var _index = that.crossPageSelectedIds().indexOf(row.getValue(that.crossPageRowPrimaryKey))
                  if (val) {
                    if (_index === -1) {
                      that.crossPageSelectedRows.push(row)
                    }
                  } else {
                    if (_index >= 0) {
                      that.crossPageSelectedRows.splice(_index, 1)
                    }
                  }
                }
                setTimeout(function () {
                  isTriggerInside = false
                })
                that.onRowSelect(row)
              }
            }))
            // setRowSelect会触发rows重新渲染,此处要避免
            // 如果当前行在已选中的ids中则设置选中（设置默认选中）这里不能使用监听对象，初始化的时候要用peek
            if (that.isEnableCrossPage && that.crossPageSelectedIds.peek().indexOf(row.getValue(that.crossPageRowPrimaryKey)) >= 0) {
              row.parent.addRowSelect(row)
            }
          } else {
            var newRow = !row._selected
            newRow && (row._selected = ko.observable(false))
            if (that.isEnableCrossPage) {
              // 初始化选中状态
              if (that.crossPageSelectedIds().indexOf(row[that.crossPageRowPrimaryKey]) >= 0) {
                row._selected(true)
              } else {
                row._selected(false)
              }
            }
            if (newRow) {
              row._selected.subscribe(function (val) {
                if (that.isEnableCrossPage) {
                  // 设置已选中rows的值
                  var _index = that.crossPageSelectedIds().indexOf(row[that.crossPageRowPrimaryKey])
                  if (val) {
                    if (_index === -1) {
                      params.crossPageSelectedRows.push(row)
                    }
                  } else {
                    if (_index >= 0) {
                      params.crossPageSelectedRows.splice(_index, 1)
                    }
                  }
                }
                that.onRowSelect(row)
              })
            }
          }
        })
      }
      return params.rows()
    }).extend({
      deferred: true
    })
    this.rows.subscribe(() => {
      ko.tasks.schedule(() => {
        var _el = params.$el.querySelector('.y-grid')
        if ((_el.scrollHeight > _el.clientHeight) || (_el.offsetHeight > _el.clientHeight)) {
          this.hasVerticalSroll(true)
        } else {
          this.hasVerticalSroll(false)
        }
      })
    })
    // 用于存储对应关系
    this.columns1UniqueKeys = {}
    this.columns1 = ko.computed(() => {
      if (params.columns1) {
        var _columns1 = []
        params.columns1().forEach((col) => {
          if (!col.loop) {
            _columns1.push(col)
          } else {
            // 有数据才根据数据显示loop列
            if (this.rows().length > 0) {
              var looplength = col.looplength(this.rows()[0])
              for (var i = 0; i < looplength; i++) {
                var title = ''
                // 为了支持索引自定义
                if (typeof (col.title) === 'function') {
                  title = col.title(i + 1, looplength)
                } else {
                  title = col.title.replace('{n}', i + 1)
                }
                var _col = Object.assign({}, col, {
                  title: title
                })
                _columns1.push(_col)
              }
              if (ko.isObservable(this.columns1UniqueKeys[col.uniqueKey])) {
                this.columns1UniqueKeys[col.uniqueKey](looplength)
              } else {
                this.columns1UniqueKeys[col.uniqueKey] = ko.observable(looplength)
              }
            } else {
              this.columns1UniqueKeys[col.uniqueKey] = ko.observable(0)
            }
          }
        })
        return _columns1
      } else {
        return []
      }
    })
    // 暂定只支持ko对象
    this.columns2 = ko.computed(() => {
      if (params.columns2) {
        var _columns2 = []
        params.columns2().forEach((col) => {
          if (!col.loop) {
            _columns2.length++
          } else {
            _columns2.length += this.columns1UniqueKeys[col.uniqueKey]()
          }
        })
        var crossLength = _.groupBy(params.columns2().map((col) => {
          return {
            key: col.uniqueKey
          }
        }), 'key')
        var index = 0
        params.columns2().forEach((col) => {
          // 找到第一个没有赋值的列然后塞入
          while (_columns2[index]) {
            index++
          }
          if (!col.loop) {
            _columns2[index] = col
            index++
          } else {
            var _length = this.columns1UniqueKeys[col.uniqueKey]()
            for (var i = 0; i < _length; i++) {
              _columns2[index + i * crossLength[col.uniqueKey].length] = Object.assign({}, col, {
                _childIndex: i
              })
            }
            // 计算索引
            if (_length > 0) {
              index++
            }
          }
        })
        return _columns2
      } else {
        return []
      }
    })
    let findMaxSortIndex = (cols) => {
      // columns.push方法获取的sortIndex是错误的
      // TODO: 需要splice的情况
      let hasSortIndex = cols.filter(item => {
        return item.sortIndex || item._sortIndex
      }).map(item => {
        return {
          sortIndex: item.sortIndex || item._sortIndex
        }
      })
      if (hasSortIndex.length === 0) {
        return cols.length
      } else {
        return hasSortIndex.reduce((prev, next) => {
          if (prev.sortIndex > next.sortIndex) {
            return prev
          } else {
            return next
          }
        }, { sortIndex: 0 }).sortIndex
      }
    }
    // 添加ycloud 列顺序，如果columns存在sort属性，则会根据sort进行重新排序
    this.sortColumn = (columns) => {
      if (this.isRowspanHead) {
        return columns
      }
      var sortedCols = []
      var allColumns = findMaxSortIndex(columns)
      columns.forEach((col, index) => {
        if (!col.sortIndex) {
          col._sortIndex = ++allColumns
        } else {
          if (window.isNaN(Number(col.sortIndex))) {
            console.error(`columns ${col.field}'s props sortIndex should be a Number`)
          } else {
            // 现在的算法会给没有sortIndex的列也添加sortIndex（改成添加_sortIndex）
            // 如果有sortIndex则优先级变得很高, -100 保证有sortInde肯定在前面，一般来说100列够用列
            col._sortIndex = col.sortIndex - 100
          }
        }
        sortedCols.push(col)
      })
      sortedCols.sort((pre, next) => {
        return pre._sortIndex - next._sortIndex
      })
      return sortedCols
    }
    // 支持外部重新设置表格的顺序
    this.resetColumnSortIndex = (fieldMap) => {
      if (!ko.isObservable(params.columns)) {
        console.error('使用resetColumnSortIndex，传入的columns需要是ko.observableArray对象！')
      } else {
        var originFieldIndexMap = {}
        params.columns().forEach((col, index) => {
          if (col.field) {
            if (originFieldIndexMap[col.field]) {
              console.warn('存在重复的field定义，请确认')
            }
            originFieldIndexMap[col.field] = index
          }
        })
        Object.keys(fieldMap).forEach(function (field) {
          var colIndex = originFieldIndexMap[field]
          if (isNaN(colIndex)) {
            console.error('field:' + field + '在原columns中不存在，请确认！')
          } else {
            params.columns()[colIndex].sortIndex = fieldMap[field]
          }
        })
        params.columns.splice(0, 0)
      }
    }
    // 在需要的时候重新计算列
    this.triggerReset = ko.observable(false)
    this.colsWidth = ko.observable(0)
    let cacheOffsetWidth = 0
    this.fullWidth = (cols) => {
      var colWidth = cols.map(cell => {
        return cell._width || cell.width
      }).reduce((a, b) => Number(a || 0) + Number(b || 0), 0)
      this.colsWidth(colWidth)
      var outerCtnWidth = 0
      // 缓存数据，防止重复查询offsetWidth 空数组时不处理
      if (cols.length > 0) {
        if (cacheOffsetWidth === 0) {
          outerCtnWidth = params.$el.querySelector('.y-grid-wrapper').offsetWidth
          if (outerCtnWidth !== 0) {
            cacheOffsetWidth = outerCtnWidth
          }
        } else {
          var _width = params.$el.querySelector('.y-grid-wrapper').offsetWidth
          // 滚动条差异 取小的
          cacheOffsetWidth = Math.abs(_width - cacheOffsetWidth) < 20 ? Math.min(_width, cacheOffsetWidth) : _width
          outerCtnWidth = cacheOffsetWidth
        }
      }
      return outerCtnWidth > colWidth
    }
    // 表格的宽度
    let resetChildrenWidth = (children, width) => {
      var size = children.length
      var delta = Number(width / size).toFixed(2) - 0
      children.forEach(col => {
        if (!col._width) {
          col._width = col.width
        }
        col.width = (col._width + '').replace('px', '') - 0 + delta
        if (col.children) {
          resetChildrenWidth(col.children, delta)
        }
      })
    }
    // 计算真是的columns列
    this.columns = ko.computed(() => {
      var columns = []
      // 重新计算宽度base
      this.triggerReset()
      // 先判断是否启用columns1和columns2
      if (this.isRowspanHead) {
        var columns2 = []
        this.columns1().forEach((col) => {
          // 原来是colspan > 1才计算，实际上只要colspan有值就应该处理
          if (col.colspan) {
            var colspanlength = col.colspan
            if (columns2.length === 0) {
              columns2 = [].concat(this.columns2())
            }
            var row2columns = columns2.splice(0, colspanlength)
            columns = columns.concat(row2columns)
          } else {
            columns.push(col)
          }
        })
      }
      if (columns.length === 0) {
        columns = params.columns
      }
      // 出事化列内置一些属性 _show 用来隐藏和显示列
      let columnsValue = columns
      if (ko.isObservable(columns)) {
        columnsValue = columns()
      }
      columnsValue.forEach((col, index) => {
        // checkbox设定特殊宽度
        if (col.type === 'checkbox') {
          col.width = 35
        } else {
          //  某个版本存在设置minWidth不设置width的场景
          if (col.minWidth) {
            col.width = col.minWidth
          }
          let _width = col.width
          // 把字符串都转成数字
          if (_width && typeof _width === 'string') {
            try {
              col.width = Number(_width.replace('px', ''))
            } catch (e) {
              console.error('表格列宽度:' + _width + '请设置成数字或合法字符串')
            }
          }
        }
        col.observeTitle = col.observeTitle || false
        col._show = col._show ? col._show : ko.observable(!col.hidden)
        // 如果不是lazy 那么 所有的都是需要渲染的
        col._needRender = col._needRender || ko.observable(col.needRender || !this.lazy || col.lockright)
      })
      // 原来column1 + columns2 的情况不处理
      if (!params.columns1) {
        var showColumn = columnsValue.filter(col => {
          return ko.utils.unwrapObservable(col._show)
        })
        if (this.fullWidth(showColumn) && this.colsWidth() > 0 && cacheOffsetWidth) {
          // 计算要依托于最基础的宽度
          var _colsWidth = showColumn.reduce((pre, next) => {
            pre.width = pre.width + (next._width || next.width)
            return pre
          }, {
            width: 0
          }).width
          var delta = Number((cacheOffsetWidth - _colsWidth) / showColumn.length).toFixed(2) - 0
          if (delta > 0) {
            // 如果需要计算 把默认y-grid的overflow设置成hidden
            params.$el.querySelector('.y-grid').style['overflow-x'] = 'hidden'
            showColumn.forEach((col, index) => {
              // 尾差减去1px
              let lastColumnWidthFixed = (index === 0) ? 1 : 0
              if (col.width) {
                // 把老的宽度缓存下来
                if (!col._width) {
                  col._width = col.width
                }
                col.width = (col._width + '').replace('px', '') - lastColumnWidthFixed + delta
              }
              if (col.children) {
                resetChildrenWidth(col.children, delta - lastColumnWidthFixed)
              }
            })
          } else {
            params.$el.querySelector('.y-grid').style['overflow-x'] = ''
          }
        }
      }
      return this.sortColumn(columnsValue)
    })
    // 用于计算当前列索引的宽度
    this.columnsWidth = ko.computed(() => {
      let _colsWidth = []
      let showColWidth = 0
      this.columns().forEach((col, index) => {
        let _show = null
        // 可能存在设置固定值的情况
        if (typeof col._show === 'function') {
          _show = col._show()
        } else {
          _show = !!col._show
        }
        if (_show) {
          showColWidth += col.width || 0
          // 显示了才触发
          if (showColWidth <= clientWidth) {
            col._needRender(true)
          }
        }
        _colsWidth.push(col.width || 0)
      })
      return _colsWidth
    })
    this.convertedRows = ko.computed(() => {
      if (this.isRowspanHead) {
        return this.columns()
      } else {
        return util.convertToRowsHeader(this.columns())
      }
    })
    this.convertedColumns = ko.computed(() => {
      let columns = util.getAllColumns(this.columns())
      return columns
    })
    this.lockleftColumns = ko.computed(() => {
      let _columns = this.columns().filter(col => {
        return col.lock
      })
      // 补充列用于填充行，方便行列合并计算
      _columns.push({
        title: '',
        type: 'render',
        _show: true,
        hideTd: true,
        width: 0,
        _needRender: ko.observable(false),
        renderFn: function (row, index) {
          return index % 2
        }
      })
      return _columns
    })
    // 只有表格数据大于10条才显示分页
    this.isShowPagination = ko.computed(() => {
      return params.pagination && this.totalCount() > Math.min.apply(null, params.pageSizeList ? params.pageSizeList.concat([10]) : [10])
    })
    this.hasVerticalSroll = ko.observable(false)
    this.tableWidth = ko.computed(() => {
      let cols = this.columns()
      this.reComputedTableWidth()
      const isUseOuterWidth = cols.some(cell => isNaN(cell.width))
      if (isUseOuterWidth) {
        return '100%'
      } else {
        return this.colsWidth() + 'px'
      }
    })
    this.fixBodyHeight = ko.pureComputed(() => {
      if (this.height !== 'auto') {
        return this.computedMaxHeight().replace('px', '') - this.scrollHeight.replace('px', '') + 'px'
      } else {
        return 'auto'
      }
    })
    // 计算锁定列的宽度
    this.fixedTableWidth = ko.pureComputed(() => {
      let cols = this.columns()
      this.triggerReset()
      // lock列需要指定宽度
      const isUseOuterWidth = cols.filter(cell => cell.lock).filter(cell => cell._show()).some(cell => isNaN(cell.width))
      if (isUseOuterWidth) {
        return '0px'
      } else {
        return cols.filter(cell => cell.lock).filter(cell => cell._show()).map(cell => cell.width).reduce((a, b) => Number(a) + Number(b), 0) + 'px'
      }
    })
    this.fixedLockRightTableWidth = ko.pureComputed(() => {
      let cols = this.columns()
      // lock列需要指定宽度
      const isUseOuterWidth = cols.filter(cell => cell.lockright).filter(cell => cell._show()).some(cell => isNaN(cell.width))
      if (isUseOuterWidth) {
        return '0px'
      } else {
        return cols.filter(cell => cell.lockright).filter(cell => cell._show()).map(cell => cell.width).reduce((a, b) => Number(a) + Number(b), 0) + 'px'
      }
    })
    // grid下有传入自定义组件
    this.hasMarkup = ko.computed(() => {
      if (this.$templateNodes.length > 0) {
        let nodeList = this.$templateNodes.filter((node) => {
          return node.nodeName !== '#text' && node.nodeName !== '#comment'
        })
        return nodeList.length > 0
      } else {
        return false
      }
    })
    // 全选
    this.allRowChecked = ko.computed({
      read: function () {
        var rows = params.rows()
        var flag = rows.length > 0
        for (var i = 0; i < rows.length; i++) {
          if (this.isDataTable) {
            if (!rows[i].selected()) {
              flag = false
              break
            }
          } else {
            if (rows[i]._selected) {
              if (!rows[i]._selected()) {
                flag = false
                break
              }
            } else {
              flag = false
            }
          }
        }
        return flag
      },
      write: function (isChecked) {
        if (this.isDataTable && this.crossPageSelectedRows) {
          var seletedRow = this.crossPageSelectedRows.peek()
          var seletedIds = seletedRow.map(function (val) {
            return val.getValue(that.crossPageRowPrimaryKey)
          })
          if (isChecked) {
            params.rows().forEach(row => {
              var index = seletedIds.indexOf(row.getValue(that.crossPageRowPrimaryKey))
              if (index < 0) {
                seletedRow.push(row)
                seletedIds.push(row.rowId)
              }
            })
          } else {
            params.rows().forEach(row => {
              var index = seletedIds.indexOf(row.getValue(that.crossPageRowPrimaryKey))
              if (index >= 0) {
                seletedRow.splice(index, 1)
                seletedIds.splice(index, 1)
              }
            })
          }
          this.crossPageSelectedRows(seletedRow)
        } else {
          // 如果是dataTable则直接调用dataTable的setAllRowsSelect和setAllRowsUnSelect
          if (this.isDataTable) {
            var _row = params.rows()[0]
            if (_row) {
              var dt = _row.parent
              if (isChecked) {
                dt.setAllRowsSelect()
              } else {
                dt.setAllRowsUnSelect()
              }
            }
          } else {
            params.rows().forEach(row => {
              row._selected(isChecked)
            })
            params.rows.splice(0, 0)
          }
        }
      },
      owner: this
    })
  }
  subscribe (params) {
    this.columns.subscribe(val => {
      if (this.lockright) {
        this.recomputedLockRight()
      }
    })
    this.crossPageSelectedIds.subscribe(ids => {
      if (this.isDataTable) {
        if (!isTriggerInside) {
          params.rows.peek().forEach(row => {
            if (ids.indexOf(row.getValue(this.crossPageRowPrimaryKey)) > -1) {
              row.parent.addRowSelect(row)
            } else {
              row.parent.setRowUnSelect(row)
            }
          })
        }
      }
    })
  }
  methods (params) {
    this.handleSettingBorder = (vm) => {
      Object.keys(this.setting).map(function (key) {
        if (('border' + vm.tag) === key) {
          this.setting[key](true)
        } else {
          this.setting[key](false)
        }
      }.bind(this))
    }
    this.handleSetting = () => {
      this.toolboxvisible(!this.toolboxvisible())
    }
    this.setBodyContext = Context => {
      this.children.body = Context
    }
    // 切换lockright动态显示
    this.handleToogleLockright = (vm, event) => {
      if (event.currentTarget.classList.contains('y-lock-toolbar-hide')) {
        this.showLockRightToolBar(true)
        event.currentTarget.classList.remove('y-lock-toolbar-hide')
      } else {
        this.showLockRightToolBar(false)
        event.currentTarget.classList.add('y-lock-toolbar-hide')
      }
    }
    this.recomputedLockRight = () => {
      let columns = this.columns()
      this.lockRightWidth = columns.filter(col => !col.lockright).filter(col => col._show()).map(cell => cell.width).reduce((a, b) => Number(a) + Number(b), 0)
      this.fixRightHeadtransform('translateX(-' + this.lockRightWidth + 'px)')
      this.fixRightTransform('translate(-' + this.lockRightWidth + 'px,0)')
    }

    this.resetColumnRender = _.throttle((scrollLeft) => {
      let _columnsWidth = this.columnsWidth.peek()
      let columns = this.columns.peek()
      let width = 0
      let startWidth = scrollLeft
      startWidth = startWidth > 0 ? startWidth : 0
      let endWidth = scrollLeft + clientWidth
      for (let i = 0; i < _columnsWidth.length; i++) {
        // 只计算显示的列
        if (columns[i]._show && columns[i]._show()) {
          width += columns[i].width
        }
        // 只处理可视范围内的列
        if (width >= startWidth && endWidth >= width) {
          columns[i]._needRender(true)
        } else if (width > endWidth || (width < startWidth && i > 3)) {
          // 有lazy才启用
          columns[i]._needRender(columns[i].needRender || !this.lazy || columns[i].lockright)
        }
      }
    }, 16)
    let resetGridLazy = (start, end, ignoreSet) => {
      if (!ignoreSet) {
        this.lazy.lazyStart(start)
        this.lazy.lazyEnd(end);
      }
      if (this.rowspan) {
        ko.tasks.schedule(() => {
          var body = this.children.body
          // 如果有锁定列，则只设置fix的表格，否则设置默认表格
          var domId = ko.unwrap(this.lockcolumn) ? this.domId + '_fix' : this.domId
          if (this.rowspan.maxCol) {
            body.caculateRowspan(this.rowspan.maxCol, domId, body, start)
          } else if (this.rowspan.columnIndex) {
            body.caculateRowspanByIndex(this.rowspan.columnIndex, domId, body)
          }
        })
      }
    }
    let once = false
    this.defaultHanldeScroll = _.throttle((e, scrollTop) => {
      if (this.rows.peek().length <= this.maxLazyRows) {
        this.lazy.lazyEnd(this.maxLazyRows)
        if (!once) {
          resetGridLazy(0, this.maxLazyRows, true)
        }
        once = true
        return
      }
      // 获取当前已记录的大致行索引
      var index = this.getCurIndexByScrollTop(scrollTop)
      var endIndex = index + 14
      var startIndex = index - 6
      var oldEnd = this.lazy.lazyEnd()
      var oldStart = this.lazy.lazyStart()
      if (endIndex - oldEnd >= 5 || oldStart - startIndex >= 5) {
        resetGridLazy(startIndex, endIndex)
      }
    }, 16);
    const showFixColumn = _.debounce(() => {
      this.hidefix(false)
    }, 100);
    let lastScrollLeft = 0
    this.handleScroll = (vm, event) => {
      fastDom.measure(() => {
      // 仅当锁定表头时才自动滚动列
        let scrollLeft = event.currentTarget.scrollLeft
        let scrollTop = event.currentTarget.scrollTop
        // 纵向滚动才隐藏,横向滚动不隐藏
        if (Math.abs(lastScrollLeft - scrollLeft) < 2) {
          if (this.lockhead || this.lockcolumn()) {
            this.hidefix(true)
          }
        } else {
          this.hidefix(false)
        }
        console.log('abs:', Math.abs(lastScrollLeft - scrollLeft))
        fastDom.mutate(() => {
          lastScrollLeft = scrollLeft
          this.resetColumnRender(scrollLeft)
          if (this.lockhead || this.lockcolumn()) {
            this.headtransform('translateX(-' + scrollLeft + 'px)')
            this.fixColumnTransform('translateY(-' + scrollTop + 'px)')
            if (this.verticalScroll) {
              this.vertiacalScrollTransform('translateX(-' + scrollLeft + 'px)')
            }
            this.fixRightTransform('translate(-' + this.lockRightWidth + 'px, -' + scrollTop + 'px)')
            this.lazy && this.defaultHanldeScroll(event, scrollTop, scrollLeft)
            showFixColumn()
          }
        })
      })
    }
    // 设置loading图标是否显示
    this.showLoading = (isShow) => {
      this.isShowLoading(isShow)
    }
    // 获取所有选中的行数据
    this.getSelectedRows = () => {
      let selectedRows = []
      params.rows().forEach((item) => {
        if (item._selected && item._selected()) {
          selectedRows.push(item)
        }
      })
      return selectedRows
    }
    // 设置列显示隐藏
    this.setColVisibleByField = (field, visible) => {
      this.columns().forEach((col) => {
        if (col.field === field) {
          col._show(visible)
        }
      })
      if (this.lockright) {
        this.recomputedLockRight()
      }
      this.reComputedTableWidth(!this.reComputedTableWidth())
    }
    this.setColVisibleByFields = (fields, visible, stopUpdateView) => {
      this.columns().forEach((col) => {
        if (fields.indexOf(col.field) >= 0) {
          col._show(visible)
        }
      })
      if (!stopUpdateView) {
        if (this.lockright) {
          this.recomputedLockRight()
        }
        this.reComputedTableWidth(!this.reComputedTableWidth())
      }
    }
    // 根据field获取column
    this.getColByField = (field) => {
      var curColumn = {}
      this.columns().forEach((col) => {
        if (col.field === field) {
          curColumn = col
        }
      })
      return curColumn
    }
    // 切换行是否禁止选中
    this.setRowSelectEnable = (isEnable) => {
      this.forbitRowSelect(isEnable)
    }
    this.lastScrollTop = ''
    this.handleScrollTop = (target, mainBody, bodyrefs) => {
      let scrollTop = target.scrollTop
      if (scrollTop !== this.lastScrollTop) {
        if (bodyrefs.leftBody) {
          let leftBody = bodyrefs.leftBody.querySelectorAll('.y-grid-body')[0]
          if (target !== leftBody) {
            ko.tasks.schedule(function () {
              leftBody.scrollTop = scrollTop
            })
          }
        }
        if (target !== mainBody) {
          ko.tasks.schedule(function () {
            mainBody.scrollTop = scrollTop
          })
        }
        if (bodyrefs.rightBody) {
          let rightBody = bodyrefs.rightBody.querySelectorAll('.y-grid-body')[0]
          if (target !== rightBody) {
            ko.tasks.schedule(function () {
              rightBody.scrollTop = scrollTop
            })
          }
        }
      }
      this.lastScrollTop = scrollTop
    }
    this.handleScrollLeft = (target, mainBody, bodyrefs) => {
      if (target !== mainBody) {
        if (bodyrefs.leftBody) {
          let leftBody = bodyrefs.leftBody.querySelectorAll('.y-grid-body')[0]
          if (target === leftBody) {
            ko.tasks.schedule(function () {
              leftBody.scrollLeft = 0
            })
          }
        }
        if (bodyrefs.rightBody) {
          let rightBody = bodyrefs.rightBody.querySelectorAll('.y-grid-body')[0]
          if (target === rightBody) {
            rightBody.scrollLeft = 0
          }
        }
      } else {
        let mainHead = bodyrefs.mainbody.querySelectorAll('.y-grid-head')[0]
        ko.tasks.schedule(function () {
          mainHead.scrollLeft = target.scrollLeft
        })
      }
    }
    this.handleBodyScroll = (vm, e) => {
      const target = e.target
      let bodyrefs = this.bodyrefs
      var mainBody = bodyrefs.mainbody.querySelectorAll('.y-grid-body')[0]
      this.handleScrollLeft(target, mainBody, bodyrefs)
      this.handleScrollTop(target, mainBody, bodyrefs)
    }
  }
  created (params) {
    if (this.lockright) {
      this.recomputedLockRight()
    }
  }
}
export default Grid



// WEBPACK FOOTER //
// ./src/components/grid/base.js